const IS_EN_DIR = /\/en(\/|$)/.test(window.location.pathname)
const BASE_DIR = IS_EN_DIR ? '..' : '.'

export const LANG_CONFIG = {
  zh: {
    loadingText: '正在加载中...',
    imgBase: './images/zh/',
    apiBanner: 'fbpsd_zh_banner',
    apiHome: 'fbpsd_zh_home',
    apiContent: 'fbpsd_zh_content',
    showVideo: true,
    showTapTap: false,
    showQrcode: true,
    title: 'Roguelite弹幕射击游戏',
    keywords:
      '风暴怕死队、怕死、肉鸽、弹幕射击、射击、猎魔人、枪械、特效枪头、秘宝合成、塔罗牌、胡牌、词缀 、刷宝、组合、BD、中世纪、逃亡',
    description:
      '《风暴怕死队》是一款Roguelite弹幕射击游戏。一场魔女之灾突然来临，混沌的魔力化作了风暴之墙，巨大海浪与风暴将主岛围住，没有任何东西可以穿过它。在风暴之墙内，混沌魔力的侵蚀正在扩散，生灵正在逐渐腐化为怪物。而你则是一名被困在岛上的猎魔人，在明天的太阳升起之前，你需要想尽一切办法逃离这座已经变成人间地狱的小岛。',
    socials: [
      {
        type: 'qq',
        img: 'icon_qq.png',
        alt: 'qq群',
        href: 'javascript:void(0)',
        qrcode: 'qq_qrcode.png'
      },
      {
        type: 'bilibili',
        img: 'icon_bilibili.png',
        alt: 'Bilibili',
        href: 'https://space.bilibili.com/3690977608862523?spm_id_from=333.1387.0.0'
      },
      {
        type: 'box',
        img: 'icon_blank_box.png',
        alt: '黑盒子',
        href: 'https://www.xiaoheihe.cn/bbs/user_profile_share?user_id=40ab6c803c97&h_src=heyboxapp'
      }
    ],
    tapUrl: 'https://l.taptap.cn/ISYwvtbt',
    footerType: 'zh',
    newsBanner: './images/zh/banner.png',
    newsTitle: '新闻资讯',
    posLabel: '您的位置：',
    posHome: '官网首页',
    posNews: '新闻资讯',
    posDetail: '新闻详情',
    prevPage: '上一页',
    nextPage: '下一页',
    categoryNames: {
      latest: '最新',
      news: '新闻',
      notice: '公告',
      event: '活动'
    }
  },
  en: {
    loadingText: 'Loading...',
    imgBase: './images/en/',
    apiBanner: 'fbpsd_en_banner',
    apiHome: 'fbpsd_en_home',
    apiContent: 'fbpsd_en_content',
    showVideo: false,
    showQrcode: false,
    title: 'Multiplayer Roguelite Bullet-Hell Shooter',
    keywords:
      'Pass the fear, Pass, Roguelite, bullet-hell shooter, shooting, Demon hunter, Weapons,  barrels, fusions, Tarot Cards,tile jackpot,affixes,Looting,Synergy, BD, Medieval, Escape',
    description:
      'PASS THE FEAR is a  multiplayer roguelite bullet-hell shooter. A catastrophic Witch’s Disaster strikes without warning, and chaotic magic transforms into the ancient Wall of Storms—towering waves and raging tempests that encircle the main island. Nothing goes in. Nothing gets out. Inside this barrier, the corruption of chaotic magic spreads relentlessly, twisting every living creature into grotesque monsters. And you? You’re a demon hunter trapped within this hellscape. Before dawn breaks, you must find a way to escape this island that’s  turning into a living nightmare.',
    socials: [
      {
        type: 'x',
        img: 'icon_qq.png',
        alt: 'x',
        href: 'https://x.com/PassTheFear'
      },
      {
        type: 'youtube',
        img: 'icon_bilibili.png',
        alt: 'youtube',
        href: 'https://www.youtube.com/@PasstheFear'
      },
      {
        type: 'discord',
        img: 'icon_blank_box.png',
        alt: 'discord',
        href: 'https://discord.gg/PKSA5FBMGg'
      }
    ],
    tapUrl: '',
    footerType: 'en',
    newsBanner: './images/en/news_banner.png',
    newsTitle: 'NEWS',
    posLabel: 'Your Position: ',
    posHome: 'Home',
    posNews: 'News',
    posDetail: 'Detail',
    prevPage: 'Prev',
    nextPage: 'Next',
    categoryNames: {
      latest: 'Latest',
      news: 'News',
      notice: 'Notice',
      event: 'Events'
    }
  }
}

export function getInitLang() {
  const params = new URLSearchParams(window.location.search)
  const lang = params.get('lang')
  if (lang === 'en') return 'en'
  if (lang === 'zh') return 'zh'
  return IS_EN_DIR ? 'en' : 'zh'
}

export { IS_EN_DIR, BASE_DIR }
